
import { Options } from "vue-class-component";
import { BaseDetail } from "@/script/core/view/BaseDetail";
import { ServiceContext} from "@/script/core/base/ServiceData";
import { ElMessage, ElNotification } from "element-plus";
import { createCameraContext } from "@/script/apps/device/config/DeviceConfig";
import { Camera } from "@/script/apps/device/entity/DeviceEntity";

@Options({})
export default class CameraDetail extends BaseDetail {
  public initData(): ServiceContext {
    return createCameraContext();
  }

  public newEntity() {
    const entity: Camera = {};
    return entity;
  }
}
